
export enum AttachmentSystemType {
    DEFAULT     = 1,        // used in tasks, events, etc - idea chto it is saved in attachment table
    CUSTOM      = 2         // not saved in attachments table
}